<template>
<m-pageframe
    title="Rest API Environment"
>
<v-container>

     <m-named-pair 
        text="Front End Environment"
        :value="$rc.getEnvironment()"
        hide_empty
    />

    <m-named-pair 
        text="In Dev?"
        :value="''+$rc.inDev()"
        hide_empty
    />

    <m-named-pair 
        text="In Staging?"
        :value="''+$rc.inStaging()"
        hide_empty
    />

    <m-named-pair 
        text="In Production?"
        :value="''+$rc.inProduction()"
        hide_empty
    />

    <v-btn
        v-on:click="update"
    >
        Get Rest API Environment
    </v-btn>

    <br/><br/>

    <code
        style="display: block; white-space: pre;"
        v-if="response_data != null"
    >
        {{response_data}}
    </code>

    <m-named-pair 
        text="Device Pixel Ratio"
        :value="window_pixel_ratio"
        hide_empty
    />

    <m-named-pair 
        text="Screen Height"
        :value="screen_height"
        hide_empty
    />

    <p><b>Device Fingerprint</b></p>

     <code
        style="display: block; white-space: pre;"
        v-if="rc_device_fingerprint != null"
    >
        {{rc_device_fingerprint}}
    </code>

    <p><b>Links</b></p>
    <p>
        Jim's Dev Box Link: <a href="https://kanej-front-end-redchirp.ngrok.io/app/home" target="_blank">https://kanej-front-end-redchirp.ngrok.io/app/sign-in</a>
    </p>

    <p>
        Jeff's Dev Box Link: <a href="https://jdezso-front-end-redchirp.ngrok.io/app/home" target="_blank">https://jdezso-front-end-redchirp.ngrok.io/app/sign-in</a>
    </p>

    {{$rc.isAuthActorProhibitedFromUsingFrontEnd()}}
    

</v-container>
</m-pageframe>
</template>

<script>
export default {

data() {
    return {
        'response_data' : null,
        'rc_device_fingerprint' : null,
    }
},

mounted () {
    this.update();

    this.rc_device_fingerprint = this.$rc.getFingerprint();
},

methods: {
    update() 
    {
        this.$rc.getRestAPIEnvironment(

            (data) => {
                this.response_data = data;
            },

            () => {
                this.response_data = 'Get Environment Error!'
            },
        )
    },
},

computed: {
    window_pixel_ratio() {
        return ''+window.devicePixelRatio;
    },

    screen_height() {
        return ''+screen.height;
    },
},
    
}
</script>

<style lang="scss" scoped>

</style>